module.exports = __webpack_public_path__ + "static/media/Logo.d798be41.jpg";